module.exports = __webpack_public_path__ + "img/deeper.a3068a8a.png";